<template>
  <blockquote>
    {{ value }}
  </blockquote>
</template>

<script>
export default {
  name: "ControlQuote",
  props: {
    value: {
      type: String,
      default: null,
    },
  },
};
</script>
